// ApprovedTable.jsx
import { formatDate, MappingStatus, MappingStyles } from "../../utils/utils";
import React, { useState } from "react";

export default function ApprovedTable({
  selectedAll,
  handleSelectApplicant,
  selectedApplicants,
  handleSelectAll,
  filteredApplicants,
  handleViewApplication,
  getStatusClass,
}) {
  return (
    <div className="  bg-[#131313] rounded-lg border border-[#333333] w-full  overflow-x-auto scrollbar-hide">
      <table className="min-w-full">
        <thead >
            <tr>
              <th className="p-4 text-center border-r  border-[#333333]">
                <input
                  type="checkbox"
                  className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
   before:content-['✔'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                  checked={selectedAll}
                  onChange={handleSelectAll}
                />
              </th>
              <th className="p-4 text-center border-r  border-[#333333]">
                APPLICATION ID
              </th>
              <th className="p-4 text-center border-r  border-[#333333]">
                APPLICANT NAME
              </th>
              <th className="p-4 text-center border-r  border-[#333333]">
                LOAN AMOUNT
              </th>
              <th className="p-4 text-center border-r  border-[#333333]">
                ASSIGNED DATE
              </th>
              <th className="p-4 text-center border-r  border-[#333333]">STATUS</th>
              <th className="p-4 text-center border-r  border-[#333333]">
                APPLICATION
              </th>
              <th className="p-4 text-center ">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            {(() => {
              if (!filteredApplicants || filteredApplicants.length === 0) {
                return (
                  <tr>
                    <td colSpan="9" className="p-6 text-center text-gray-400 border-none">
                      No rows found{" "}
                      {/* Adjusted colSpan if necessary, should be 8 */}
                    </td>
                  </tr>
                );
              }
              return filteredApplicants.map((distribution, index) => (
                <tr
                  key={distribution._id || index} // distribution._id is the distributionId
                  className=" text-white border-t border-gray-800"
                >
                  <td className="p-4 text-center border-r  border-[#333333]">
                    <input
                      type="checkbox"
                      className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
                       before:content-['✔'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                      checked={selectedApplicants.includes(distribution._id)} // Use distributionId
                      onChange={() => handleSelectApplicant(distribution._id)} // Changed to use handleSelectApplicant
                    />
                  </td>
                  <td className="p-4 text-center border-r  border-[#333333]">
                    <div>
                      <div>{distribution._id}</div> {/* Distribution ID */}
                      <div className="text-xs text-gray-400 mt-1">
                        {/* Displaying distribution's sentAt or createdAt */}
                        {formatDate(
                          distribution.sentAt || distribution.createdAt
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="p-4 text-center border-r  border-[#333333]">
                    {distribution.loan?.user?.name || "N/A"}{" "}
                    {/* Access nested loan.user.name */}
                  </td>
                  <td className="p-4 text-center border-r  border-[#333333]">
                    <div>
                      <div>
                        ₹
                        {distribution.loan?.principle?.toLocaleString("en-IN") ||
                          "N/A"}{" "}
                        {/* Access nested loan.principle */}
                      </div>
                      <div className="text-sm text-gray-400 mt-1">
                        {distribution.loan?.loanType || "N/A"}{" "}
                        {/* Access nested loan.loanType */}
                      </div>
                    </div>
                  </td>
                  <td className="p-4 text-center border-r  border-[#333333]">
                    {/* Date when distribution was responded to or updated */}
                    {formatDate(distribution.updatedAt)}
                  </td>
                  <td className="p-4 text-center border-r  border-[#333333]">
                    {/* Status of the LoanDistribution */}
                    <span
                      className={`px-4 py-1 rounded-full text-sm ${getStatusClass(
                        distribution.status
                      )}`}
                    >
                      {distribution.status}
                    </span>
                  </td>

                  <td className="p-4 text-center border-r  border-[#333333]">
                    <button
                      className="text-yellow-500 hover:text-yellow-400"
                      onClick={() => handleViewApplication(distribution._id)} // Pass distributionId
                    >
                      View
                    </button>
                  </td>
                  <td>
                    <div className="flex items-center gap-2 justify-center">
                      <button>
                        <span className="text-yellow-500 hover:text-yellow-400">
                          Download
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              ));
            })()}
          </tbody>
        </table>
      </div>
  );
}
